const getLabelParts = (...parts) => (
  parts
    .map(part => String(part || '').trim())
    .filter(Boolean)
);

export const getCountryCode = (country) => country?.code || '-';

export const getCurrencyCode = (currency) => currency?.currency_code || currency?.code || '-';

export const formatCountryOptionLabel = (country) => {
  const parts = getLabelParts(country?.code, country?.name);
  return parts.length > 0 ? parts.join(' - ') : 'Unnamed Country';
};

export const formatCurrencyOptionLabel = (currency) => {
  const parts = getLabelParts(currency?.currency_code || currency?.code, currency?.name);
  return parts.length > 0 ? parts.join(' - ') : 'Unnamed Currency';
};
